import { useEffect, useState, useContext } from 'react';
import {
    Box, Button, CircularProgress, Dialog, DialogContent,
    Grid, IconButton, makeStyles, Tooltip
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import CloseIcon from '@material-ui/icons/Close';
import FlipCameraAndroidIcon from '@material-ui/icons/FlipCameraAndroid';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import TuneIcon from '@material-ui/icons/Tune';
import { Alert } from '@material-ui/lab';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import DateFnsUtils from '@date-io/date-fns';
import {
    formatDateObjToSlash,
    getControlDay,
    getNextWeekMaxToday,
} from '../../helpers/common';
import Container from '../Elements/Container';
import TopNav from '../common/TopNav';
import Filter from './Filter';
import { getInstantV2 } from '../../services/meters';
import { getUserInfoFromLocalStorage } from '../../services/auth';
import DualChart from './DualChart';
import UserContext from '../../context/UserContext';

const useStyles = makeStyles(theme => ({
    dateContainer: {
        padding: '0 8px',
        color: theme.palette.common.white,
        fontSize: 16,
        '& .MuiButtonBase-root': {
            color: theme.palette.common.white,
        },
        '& .MuiInputBase-root': {
            color: theme.palette.common.white,
            width: 125,
        },
        '& .MuiInputBase-input': {
            textAlign: 'center',
        },
        '@media (max-width: 700px)': {
            display: 'none',
        },
    },
    date: {
        '& .MuiInputBase-root': {
            width: 150,
        },
    },
    nextDayBtn: {
        '&.Mui-disabled': {
            opacity: '0.5',
        },
    },
    btn: {
        margin: theme.spacing(2, 1),
        '& .MuiButton-label': {
            textTransform: 'none',
            // fontSize: 11,
            fontWeight: 700,
            color: theme.palette.primary.main,
        },
        '&.MuiButton-root': {
            backgroundColor: theme.palette.common.white,
        },
    },
    btnRefresh: {
        '&.MuiButton-root': {
            height: '30px',

            marginTop: '16px',
            backgroundColor: theme.palette.common.white,
        },
        '& .MuiButton-label': {
            textTransform: 'none',
            paddingLeft: '5px',
            // fontSize: 11,
            fontWeight: 700,
            color: theme.palette.primary.main,
        },
        '@media (max-width: 700px)': {
            marginBottom: '10px',
            marginRight: '10px',
        },
    },
    alert: {
        '@media (max-width: 700px)': {
            marginLeft: theme.spacing(0),
        },
    },
    tuneIcon: {
        '& .MuiSvgIcon-root': {
            fontSize: '1.5em',
            paddingTop: theme.spacing(0.5),
        },
    },
    circular: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '15px',
    },
    dialogStyle: {
        '& .MuiDialog-paperScrollPaper': {
            // height: '100%'
        },
        '& .MuiDialogContent-root': {
            '@media (max-width: 900px)': {
                padding: '2px'
            },
        },
        '& .MuiDialog-paper': {
            '@media (max-width: 600px)': {
                margin: '0px'
            },
        },
        '& .MuiDialog-paperFullWidth': {
            '@media (max-width: 600px)': {
                width: '100%'
            },
        },
    }
}));

export default function Instant() {
    const classes = useStyles();
    const { plan } = useContext(UserContext);
    const [sharedZoom, setSharedZoom] = useState(null);
    const filterInitialValues = {
        dispositivos: [],
        variable: '',
        granularity: '',
        selectedInitialDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000),
        selectedEndDate: new Date(),
    };
    const [filterOptions, setFilterOptions] = useState(filterInitialValues);
    const [filterPanel, setFilterPanel] = useState(true);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [limitDate, setLimitDate] = useState({
        inst_days_historic: 10,
    });
    const [tz, setTz] = useState('America/Argentina/Buenos_Aires');

    const [graphsForBasic, setGraphsForBasic] = useState([]);

    //Valida el timeZone
    useEffect(() => {
        setTz(plan?.info?.tz)
    }, [plan])

    //VARIABLES DE EL CATALOGO.
    const [varsCatalogo, setVarsCatalogo] = useState([]);
    useEffect(() => {
        const VARS_CATALOGO = plan?.sections["INSTANTANEOS"].filter(item => item.enabled);
        let array = VARS_CATALOGO?.map((elem) => {
            return {
                label: elem.tag ? elem.tag : elem.name,
                value: elem.key,
                fields: elem.fields,
                periods: elem.periods,
                phase: elem.phase,
                node: elem.node
            };
        });
        setVarsCatalogo(array)
    }, [plan])
    /////////////////////////////////////

    //Red alert
    useEffect(() => {
        if (showErrorAlert) {
            setTimeout(() => {
                setShowErrorAlert(false);
            }, 7000);
        }
    }, [showErrorAlert])
    //Aca determino cuantos dias hacia atras puede pedir data el usuario  pra evitar consultas inenecesarias al back.
    useEffect(() => {
        setLimitDate(getUserInfoFromLocalStorage());
    }, []);

    function decrementPeriod() {
        const initialDate = new Date(filterOptions.selectedInitialDate);
        const endDate = new Date(filterOptions.selectedEndDate);
        const aux = endDate.getTime() - initialDate.getTime();

        const difference = Math.ceil(aux / (24 * 60 * 60 * 1000));

        initialDate.setDate(initialDate.getDate() - difference);
        endDate.setDate(endDate.getDate() - difference);

        setFilterOptions({
            ...filterOptions,
            selectedInitialDate: initialDate,
            selectedEndDate: endDate,
        });
        handleSubmit({
            ...filterOptions,
            selectedInitialDate: initialDate,
            selectedEndDate: endDate,
        });
    }

    function incrementPeriod() {
        const initialDate = new Date(filterOptions.selectedInitialDate);
        const endDate = new Date(filterOptions.selectedEndDate);
        const aux = endDate.getTime() - initialDate.getTime();
        const difference = Math.ceil(aux / (1000 * 3600 * 24));
        initialDate.setDate(initialDate.getDate() + difference);
        endDate.setDate(endDate.getDate() + difference);

        setFilterOptions({
            ...filterOptions,
            selectedInitialDate: initialDate,
            selectedEndDate: endDate,
        });

        handleSubmit({
            ...filterOptions,
            selectedInitialDate: initialDate,
            selectedEndDate: endDate,
        });
    }

    const togglePanel = () => {
        setFilterPanel(!filterPanel);
    };

    const handleSubmit = filter => {
        if (filter.dispositivos.length > 0) {
            handleClose();
            fetchDataForGraphs(filter)
        }
    };

    const fetchDataForGraphs = async (filter) => {
        try {
            let var1 = varsCatalogo.find(e => e.value === "POTENCIA_ACTIVA_POR_FASE")
            let var2 = varsCatalogo.find(e => e.value === "POTENCIA_REACTIVA_POR_FASE")
            let var3 = varsCatalogo.find(e => e.value === "TENSION_POR_FASE")
            let var4 = varsCatalogo.find(e => e.value === "CORRIENTE_POR_FASE")
            const fields = `${var1.fields},${var2.fields},${var3.fields},${var4.fields}`
            let varsCatalogToShow = [var1, var2, var3, var4]

            let url = ``
            filter.dispositivos.forEach((set, index) => {
                if (index > 0) {
                    url += '&';
                }
                url += `filter=${set.node.id}`;
                if (set.label.nombre) {
                    url += `+`;
                    url += `${set.label.id}`;
                }
            });
            url += `&response_format=v2`;
            url += `&from=${formatDateObjToSlash(filter.selectedInitialDate)}`;
            url += `&to=${formatDateObjToSlash(filter.selectedEndDate)}`;
            url += `&granularity=${filter.granularity?.replace('Minutos', '').trim()}`
            url += `&fields=${fields}`;
            setLoading(true)
            let results = []
            let res = await getInstantV2(url)
            if (res) {
                let extractFields = (varX) => {
                    let fields = {};
                    varX.fields
                        .split(",")
                        .map(f => f.trim().toUpperCase())
                        .forEach(f => {
                            for (const key in res.data[0].data) {
                                if (key === f) {
                                    fields[key] = res.data[0].data[key];
                                }
                            }
                        });
                    return {
                        ...res.data[0],
                        data: fields
                    };
                };
                let extractedFieldsVar1 = [extractFields(var1)];
                let extractedFieldsVar2 = [extractFields(var2)];
                let extractedFieldsVar3 = [extractFields(var3)];
                let extractedFieldsVar4 = [extractFields(var4)];
                results.push(extractedFieldsVar1, extractedFieldsVar2, extractedFieldsVar3, extractedFieldsVar4);
            }
            let graphs = []
            for (let index = 0; index < results.length; index++) {
                let graph = {
                    chartData: results[index],
                    chartOptions: {
                        ...filter,
                        granularity: 15,
                        variable: varsCatalogToShow[index].value
                    }
                }
                graphs.push(graph)
            }
            setGraphsForBasic(graphs)
        }
        catch (error) {
            setLoading(false);
            if (error.response) {
                setErrorMessage(
                    `${error.response.data.msg}.`
                );
            }
            else {
                setErrorMessage(`Ocurrió un error inesperado`);
            }
            setShowErrorAlert(true);
        }
        setLoading(false)
    }

    //Hanle date del filtro Este handle solamente maneja el date de el filtro el cual se activa con el boton consultar
    const handleDateChange = (date, field, topNav) => {
        let differenceBetweens =
            format(date, 'MM/dd/yyyy') <
            getControlDay(
                filterOptions.selectedEndDate,
                limitDate?.menu?.inst_days_request
            );
        //Este if es para q ue si la primer fecha DESDE es mayor a la segunda fecha HASTA  la iguale a primera.
        if (
            field === 'selectedInitialDate' &&
            date > filterOptions.selectedEndDate
        ) {
            setFilterOptions({
                ...filterOptions,
                selectedEndDate: date,
                [field]: date,
            });
            if (topNav === 'nav') {
                handleSubmit({
                    ...filterOptions,
                    selectedEndDate: date,
                    [field]: date,
                });
            }
        }
        //Este if es para q si la fecha DESDE es inferior a la cantidad de dias q tiene eñ usuario con respecto a HASTA calendario.
        else if (
            field === 'selectedInitialDate' &&
            differenceBetweens &&
            date < filterOptions.selectedEndDate
        ) {
            //Aca cambio la fecha de nuevo a formato Wed Sep 21 2022 17:38:00 GMT-0300 (Argentina Standard Time)
            let aux = new Date(
                getNextWeekMaxToday(date, limitDate?.menu?.inst_days_request)
            );
            setFilterOptions({
                ...filterOptions,
                selectedEndDate: aux,
                [field]: date,
            });
            if (topNav === 'nav') {
                handleSubmit({
                    ...filterOptions,
                    selectedEndDate: date,
                    [field]: date,
                });
            }
        } else {
            setFilterOptions({
                ...filterOptions,
                [field]: date,
            });
            if (topNav === 'nav') {
                handleSubmit({
                    ...filterOptions,
                    [field]: date,
                });
            }
        }
    };

    const handleClose = () => {
        setFilterPanel(false);
    };

    const isFuture = someDate => {
        const today = new Date();
        return someDate > today;
    };

    return (
        <>
            <TopNav
                titulo="Analisis"
                subtitulo="| Instantáneos"
                changeTitleStyleFlex={true}
            >
                <Grid container justifyContent="flex-end">
                    {limitDate && (
                        <Box
                            className={classes.dateContainer}
                            display="flex"
                            justifyContent="center"
                        >
                            <IconButton
                                aria-label="período anterior"
                                onClick={decrementPeriod}
                                disabled={loading}
                            >
                                <NavigateBeforeIcon />
                            </IconButton>

                            <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.date}
                                    readOnly={true}
                                    autoOk
                                    disableToolbar
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    value={filterOptions.selectedInitialDate}
                                    onChange={e =>
                                        handleDateChange(e, 'selectedInitialDate', 'nav')
                                    }
                                    minDate={getControlDay(
                                        new Date(),
                                        limitDate?.menu?.inst_days_historic
                                    )}
                                    maxDate={new Date()}
                                    maxDateMessage=""
                                    minDateMessage=""
                                    KeyboardButtonProps={{
                                        'aria-label': 'cambiar fecha',
                                    }}
                                    InputProps={{
                                        disableUnderline: true,
                                        readOnly: true,
                                    }}
                                />
                            </MuiPickersUtilsProvider>

                            <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    readOnly={true}
                                    className={classes.date}
                                    autoOk
                                    disableToolbar
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    value={filterOptions.selectedEndDate}
                                    onChange={e => handleDateChange(e, 'selectedEndDate', 'nav')}
                                    KeyboardButtonProps={{
                                        'aria-label': 'cambiar fecha',
                                    }}
                                    InputProps={{
                                        disableUnderline: true,
                                        readOnly: true,
                                    }}
                                    minDate={new Date(filterOptions.selectedInitialDate)}
                                    maxDate={getNextWeekMaxToday(
                                        filterOptions.selectedInitialDate,
                                        limitDate?.menu?.inst_days_request
                                    )}
                                    maxDateMessage=""
                                    minDateMessage=""
                                />
                            </MuiPickersUtilsProvider>
                            <IconButton
                                className={classes.nextDayBtn}
                                aria-label="período siguiente"
                                onClick={incrementPeriod}
                                disabled={isFuture(filterOptions.selectedEndDate) || loading}
                            >
                                <NavigateNextIcon />
                            </IconButton>
                        </Box>
                    )}

                    <Button
                        className={classes.btn}
                        type="button"
                        onClick={togglePanel}
                        size="small"
                        startIcon={filterPanel ? <ClearIcon /> : <TuneIcon />}
                    >
                        | Filtrar
                    </Button>

                    {/* Boton refresh */}
                    <Tooltip
                        title="Última consulta."
                        arrow
                    >
                        <Button
                            className={classes.btnRefresh}
                            type="button"
                            onClick={() => handleSubmit(filterOptions)}
                            // size='small'
                            startIcon={<FlipCameraAndroidIcon />}
                        ></Button>
                    </Tooltip>

                </Grid>
            </TopNav>

            <Dialog
                className={classes.dialogStyle}
                open={filterPanel}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth="lg"
                disableScrollLock
            >
                <DialogContent>
                    <Filter
                        varsCatalogo={varsCatalogo}
                        onSubmit={handleSubmit}
                        filter={filterOptions}
                        setFilterPanel={setFilterPanel}
                        handleDateChange={handleDateChange}
                        limitDate={limitDate}
                        setFilterOptions={setFilterOptions}
                    />
                </DialogContent>
            </Dialog>

            <Container>
                {showErrorAlert ? (
                    <Box className={classes.alert}>
                        <Alert
                            severity="error"
                            action={
                                <IconButton
                                    aria-label="close"
                                    // color='error'
                                    size="small"
                                    onClick={() => {
                                        setShowErrorAlert(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            {errorMessage}
                        </Alert>
                    </Box>
                ) : null}

                <Alert className={classes.alert} severity="info">
                    Bienvenido a Instantáneos. En esta sección podrá consultar la
                    información de consumos instantáneos de sus dispositivos. Para
                    comenzar haga click en el botón
                    <span className={classes.tuneIcon}>
                        <TuneIcon />
                    </span>
                    , ingrese los parámetros y haga click en CONSULTAR.
                </Alert>

                {loading ? (
                    <div className={classes.circular}>
                        <CircularProgress />
                    </div>
                ) : (
                    <>
                        <Box display={'flex'} gap={2} flexWrap={'wrap'} mt={2}>
                            {
                                graphsForBasic.map((graph, index) => (
                                    <DualChart
                                        key={index}
                                        tz={tz}
                                        chartData={graph.chartData}
                                        chartOptions={graph.chartOptions}
                                        ky={index}
                                        width='100%'
                                        sharedZoom={sharedZoom}
                                        onZoomChange={setSharedZoom}
                                    />
                                ))
                            }
                        </ Box>
                    </>
                )}
            </Container>
        </>
    );
}
